export class RegistrationApiError extends Error {
  readonly status: number;
  readonly body?: unknown;

  constructor(status: number, message: string, body?: unknown) {
    super(message);
    this.name = 'RegistrationApiError';
    this.status = status;
    this.body = body;
  }
}
